import { styled } from '@/styles/stitches';

export const ToastIconContainer = styled('img', {
  width: '44px',
  height: '44px',
});
